// extracted by mini-css-extract-plugin
module.exports = {"donut":"_spin_donut___yv4A","donutSpin":"_spin_donutSpin__UKVaX"};